import type { Template } from "@/types";

export const LA_03_H1_V2: Template[] = [
    {
        id: "la-03-h1v2-01",
        name: "LA 01 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 84, y: 107, width: 508, height: 317, rotation: 0, imageRotation: 0 },
            { id: "2", x: 748, y: 75, width: 262, height: 382, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1018, y: 75, width: 262, height: 382, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-02",
        name: "LA 02 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 72, y: 75, width: 262, height: 382, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 75, width: 262, height: 382, rotation: 0, imageRotation: 0 },
            { id: "3", x: 760, y: 107, width: 508, height: 317, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-03",
        name: "LA 03 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 53, y: 45, width: 306, height: 442, rotation: 0, imageRotation: 0 },
            { id: "2", x: 367, y: 45, width: 620, height: 442, rotation: 0, imageRotation: 0 },
            { id: "3", x: 995, y: 45, width: 305, height: 442, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-04",
        name: "LA 04 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 53, y: 45, width: 306, height: 442, rotation: 0, imageRotation: 0 },
            { id: "2", x: 367, y: 45, width: 305, height: 442, rotation: 0, imageRotation: 0 },
            { id: "3", x: 681, y: 45, width: 620, height: 442, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-05",
        name: "LA 05 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 38, y: 36, width: 598, height: 458, rotation: 0, imageRotation: 0 },
            { id: "2", x: 769, y: 107, width: 241, height: 343, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1018, y: 107, width: 241, height: 343, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-06",
        name: "LA 06 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 66, y: 66, width: 543, height: 399, rotation: 0, imageRotation: 0 },
            { id: "2", x: 804, y: 120, width: 207, height: 291, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1019, y: 120, width: 206, height: 291, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-07",
        name: "LA 07 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 59, y: 68, width: 276, height: 396, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 68, width: 275, height: 396, rotation: 0, imageRotation: 0 },
            { id: "3", x: 745, y: 68, width: 539, height: 396, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-08",
        name: "LA 08 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 51, y: 36, width: 305, height: 459, rotation: 0, imageRotation: 0 },
            { id: "2", x: 364, y: 36, width: 624, height: 459, rotation: 0, imageRotation: 0 },
            { id: "3", x: 996, y: 36, width: 305, height: 459, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-09",
        name: "LA 09 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 69, y: 112, width: 219, height: 307, rotation: 0, imageRotation: 0 },
            { id: "2", x: 296, y: 112, width: 219, height: 307, rotation: 0, imageRotation: 0 },
            { id: "3", x: 588, y: 0, width: 764, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-03-h1v2-10",
        name: "LA 10 - H1V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-03-h1_v2_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 131, y: 120, width: 204, height: 292, rotation: 0, imageRotation: 0 },
            { id: "2", x: 343, y: 120, width: 203, height: 292, rotation: 0, imageRotation: 0 },
            { id: "3", x: 714, y: 43, width: 601, height: 447, rotation: 0, imageRotation: 0 }
        ],
    }
];